

/* Unité monaitaire*/
let cur = ' FCFA';
let curSpanSmall = `<span class="price-currency-small">`+cur+`</span>`;
let curSpanMedium = `<span class="price-currency-medium">`+cur+`</span>`;
/*Variables pour l'ajout de l'unité monétaire */
let listPrice = document.querySelectorAll(".price");
const listSale = document.querySelectorAll(".product-price .price-sale");
const listCompare = document.querySelectorAll(".product-price .price-compare");


/* Ajout unité page Boutique*/
for(let i = 0; i < listPrice.length; i++){
    listPrice[i].innerHTML = listPrice[i].textContent.replace(/,/g, " ")+curSpanSmall;

}
for(let i = 0; i < listSale.length; i++){
    listSale[i].innerHTML = listSale[i].textContent.replace(/,/g, " ")+curSpanSmall;

}
for(let i = 0; i < listCompare.length; i++){
    listCompare[i].innerHTML = listCompare[i].textContent.replace(/,/g, " ")+cur;
}


/* Ajout unité page de details produit*/
const listDetailSale = document.querySelectorAll(".product-details_price-inner .price-sale");

for(let i = 0; i < listDetailSale.length; i++){
    listDetailSale[i].innerHTML = listDetailSale[i].textContent.replace(/,/g, " ")+curSpanMedium;
}

/* Ajout unité page panier produit*/
const listCartSale1 = document.querySelectorAll(".js-cart-total-price");
for(let i = 0; i < listCartSale1.length; i++){
    listCartSale1[i].innerHTML = listCartSale1[i].textContent.replace(/,/g, " ")+curSpanMedium;
}

const listCartSale2 = document.querySelectorAll(".js-total-price");
for(let i = 0; i < listCartSale2.length; i++){
    listCartSale2[i].innerHTML = listCartSale2[i].textContent.replace(/,/g, " ")+curSpanMedium;
}


/*Whatsapp Button**/


var btnpay = document.querySelector('[data-shopify="payment-button"]');

var content = '<a href="#" class="shopify-payment-button__button">Teste</a>';


const box = document.createElement("div");
box.innerHTML = '<a href="#" id="whatsappbtn" class="whatsappbtn" target="_blank">Discuter sur whatsapp</a>';
box.classList.add("box");
const divv = document.querySelectorAll(".porduct-details");

for(let i = 0; i < divv.length; i++){
    divv[i].appendChild(box);
}

const sh = document.getElementsByClassName("shipping-time");
sh.appendChild(box);


var prodname = document.getElementsByClassName("product-details_title");
textc = prodname[0].textContent;


